// The affiliate program's offer, in one place.
//
// These numbers appear on the marketing page and again in the affiliate terms,
// in two different registers. An offer string with two owners is how a page
// ends up promising one rate while the terms it links to state another, so both pages
// read them from here and neither one spells a figure itself.
//
// Every figure here has a counterpart in server/internal/affiliates, which is
// where the promise is actually enforced. These are the words; those are the
// arithmetic. Change one and the other has to change with it.

/** `10%`, for prose. Trailing zeros are dropped, so 10% is not `10.0%`. */
const percent = (fraction: number): string =>
  `${(fraction * 100).toLocaleString('en-US', { maximumFractionDigits: 2 })}%`;

/** Share of each qualifying top-up an affiliate earns. The fraction is the
 *  owner and the label is derived from it, because a page that promises one
 *  rate beside a calculator that pays another is exactly the drift this file
 *  exists to prevent. */
const COMMISSION_FRACTION = 0.1;
export const COMMISSION_RATE = percent(COMMISSION_FRACTION);

/** How long a referred account keeps earning, from first attribution. */
export const WINDOW_MONTHS = 6;

/** Premium for taking commission as AnyAPI balance instead of cash. */
const CREDIT_PREMIUM_FRACTION = 0.1;
export const CREDIT_PREMIUM = percent(CREDIT_PREMIUM_FRACTION);

/** Cash payouts below this roll into the next cycle rather than being paid. */
export const CASH_MINIMUM_USD = 20;

/** How long a commission stays pending before it can be withdrawn, giving a
 *  refund time to arrive and reverse it. `MaturityDays` is the other half. */
export const MATURITY_DAYS = 30;

/** How long a click is remembered before an account first attributes. */
export const ATTRIBUTION_WINDOW_DAYS = 60;

/** Cumulative annual earnings at which we ask for a tax form. Deliberately
 *  below the reporting threshold: the threshold is annual and cumulative, so
 *  waiting until it is crossed means chasing a form from someone already paid. */
export const TAX_FORM_THRESHOLD_USD = 1_000;

/** An affiliate's own link, the thing they actually paste somewhere. */
export const referralLink = (code: string): string => `https://getanyapi.com/?via=${code}`;

/** What a cash balance is worth if taken as AnyAPI credit instead. */
export const asCredit = (cashUsd: number): number => cashUsd * (1 + CREDIT_PREMIUM_FRACTION);
